// Bouqs Default Pallette
// colors taken from https://staging.bouqs.com/style_guides
// created with https://themera.vercel.app/
// TODO: add cyan and orange colors
var colors = {
  transparent: "transparent",
  text: "#333333",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  // Generated from https://maketintsandshades.com/#0a7256
  green: {
    "50": "#cee3dd",
    "100": "#9dc7bb",
    "200": "#85b9ab",
    "300": "#6caa9a",
    "400": "#3b8e78",
    "500": "#085b45",
    "600": "#09674d",
    "700": "#064434",
    "800": "#042e22",
    "900": "#144B3C"
  },
  yellow: {
    "50": "#FEF6E7",
    "100": "#FCE6BB",
    "200": "#FAD78F",
    "300": "#F8C763",
    "400": "#F5B737",
    "500": "#F3A70C",
    "600": "#C38609",
    "700": "#926407",
    "800": "#614305",
    "900": "#312102"
  },
  red: {
    "50": "#FBEAEB",
    "100": "#F3C3C8",
    "200": "#EC9DA5",
    "300": "#E47782",
    "400": "#DC505E",
    "500": "#D52A3B",
    "600": "#AA222F",
    "700": "#801924",
    "800": "#551118",
    "900": "#2B080C"
  },
  blue: {
    "50": "#EBF3F9",
    "100": "#C7DDEF",
    "200": "#A3C7E5",
    "300": "#7FB1DB",
    "400": "#5B9BD1",
    "500": "#3885C7",
    "600": "#2C6AA0",
    "700": "#215078",
    "800": "#163550",
    "900": "#0B1B28"
  },
  purple: {
    "50": "#F2ECF9",
    "100": "#DBC9ED",
    "200": "#C4A7E2",
    "300": "#AD85D6",
    "400": "#9662CB",
    "500": "#7F40BF",
    "600": "#663399",
    "700": "#4C2673",
    "800": "#33194D",
    "900": "#190D26"
  },
  pink: {
    "50": "#FFE5F2",
    "100": "#FFB8DB",
    "200": "#FF8AC4",
    "300": "#FF5CAD",
    "400": "#FF2E96",
    "500": "#FF0080",
    "600": "#CC0066",
    "700": "#99004D",
    "800": "#660033",
    "900": "#33001A"
  },
  gray: {
    "50": "#F0F2F4",
    "100": "#d2d8df",
    "200": "#BBC3CE",
    "300": "#A0ACBB",
    "400": "#8594A7",
    "500": "#6B7D94",
    "600": "#556477",
    "700": "#404B59",
    "800": "#333333",
    "900": "#15191E"
  },
  teal: {
    "50": "#EEF6F7",
    "100": "#CFE7E7",
    "200": "#B1D7D8",
    "300": "#92C8C9",
    "400": "#73B8BA",
    "500": "#54A9AB",
    "600": "#448788",
    "700": "#336566",
    "800": "#224444",
    "900": "#112222"
  }
};
export default colors;
//# sourceMappingURL=colors.js.map